<div class="tab-pane" uib-tab-content-transclude="tab">
  <app-dealer-report-log [profile]="profile"></app-dealer-report-log>
</div>
